<ng-container *transloco="let t; read: 'report-day-range-picker'">
  <div [style.visibility]="isInit ? 'visible' : 'hidden'">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-form-field>
        <mat-label>{{ t('Date range') }}</mat-label>
        <mat-date-range-input [formGroup]="dateForm" [rangePicker]="picker" [max]="maxDate">
          <input matStartDate formControlName="from" [placeholder]="t('Start')" />
          <input matEndDate formControlName="to" [placeholder]="t('End')" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker
          #picker
          (opened)="onCalendarOpened()"
          (closed)="onCalendarClosed()"
        ></mat-date-range-picker>
      </mat-form-field>
      @if (isReloading) {
        <mat-spinner [diameter]="compact ? 20 : 30"></mat-spinner>
      }
    </div>
    @if (errorDateRange) {
      <mat-error>{{ t('Range error: Start date should be before end date!') }}</mat-error>
    }
  </div>
</ng-container>
